/**
 * Groups the UI elements that can be displayed in the top toolbar.
 * Components displayed in other ui-views configure what should be displayed
 * in the top toolbar via the TopToolBarFactory service. 
 * See the comment at the top of that service for more info.
 */

export function topToolbar() {
  return {
    restrict: 'E',
    template: require('./top-toolbar.directive.html'),
    scope: {},
    controller: TopToolbarController
  };
}

TopToolbarController.$inject = ['$scope', 'TopToolbarFactory'];
function TopToolbarController($scope, TopToolbarFactory) {

  $scope.subNavBurgerClicked = subNavBurgerClicked;
  $scope.sideNavOpenerClicked = sideNavOpenerClicked;

  init();

  function sideNavOpenerClicked() {
    TopToolbarFactory.callExpandSideNavFn();
  }

  // this doesn't really belong to here, but it feels overkill to add a subnav service just for that
  function subNavBurgerClicked() {
    angular.element('#alc-sub-nav').toggleClass('toggled-by-burger');
  }

  function init() {
    $scope.config = TopToolbarFactory.getConfig();
  }

}
